import { useCallback } from "react";
import { useConceptEntitlement } from "./ConceptEntitlementContext";
import { IS_STANDALONE } from "../../standalone/config";

function buildConceptPath(
  spaceId: string,
  conceptModuleSpaceProductId: string | undefined,
  conceptCode?: string
): string | null {
  const code = conceptCode?.trim();
  const q = code ? `?concept=${encodeURIComponent(code)}&search=1` : "";
  if (IS_STANDALONE) {
    return `/tactik/concept${q}`;
  }
  const routeKey = conceptModuleSpaceProductId?.trim();
  if (!routeKey) {
    return null;
  }
  return `/space/${spaceId}/${routeKey}${q}`;
}

/** 新标签页打开「概念库」；可选带上概念编码并自动搜索 */
export function useConceptNavigate(spaceId: string) {
  const { conceptModule } = useConceptEntitlement();

  return useCallback(
    (conceptCode?: string) => {
      const path = buildConceptPath(spaceId, conceptModule?.spaceProductId, conceptCode);
      if (!path) {
        return;
      }
      window.open(path, "_blank", "noopener,noreferrer");
    },
    [conceptModule?.spaceProductId, spaceId]
  );
}
